interface Props {
  title: string;
  children: React.ReactElement;
}

export default function Tab({ title, children }: Props) {
  return <>{children}</>;
}
